var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_836)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0373 7.99297C21.5816 7.5178 21.0405 7.14086 20.4451 6.88368C19.8496 6.62651 19.2113 6.49414 18.5667 6.49414C17.9221 6.49414 17.2839 6.62651 16.6884 6.88368C16.0929 7.14086 15.5519 7.5178 15.0962 7.99297L14.1505 8.97867L13.2048 7.99297C12.2843 7.03361 11.036 6.49464 9.73425 6.49464C8.43255 6.49464 7.18416 7.03361 6.26372 7.99297C5.34327 8.95234 4.82617 10.2535 4.82617 11.6103C4.82617 12.967 5.34327 14.2682 6.26372 15.2276L7.20941 16.2133L14.1505 23.4479L21.0916 16.2133L22.0373 15.2276C22.4932 14.7526 22.8548 14.1887 23.1015 13.568C23.3483 12.9474 23.4753 12.2821 23.4753 11.6103C23.4753 10.9384 23.3483 10.2732 23.1015 9.65251C22.8548 9.03184 22.4932 8.46793 22.0373 7.99297Z",
    stroke: "#747787",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_836",
    x: -20.4826,
    y: -16.582,
    width: 73.7319,
    height: 72.0365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.23262,
    dy: 4.46523
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.3957
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0431373 0 0 0 0 0.0470588 0 0 0 0 0.0823529 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_836"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_836",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.3262,
    height: 22.3262,
    fill: "white",
    transform: "translate(3.13672 2.83691)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/Saved.8344698c230ed3183eee8c94a990080a.svg";
export { ForwardRef as ReactComponent };